import React, { useState } from "react";
import { ButtonBase, Menu, MenuItem } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";



const SortMenu = ({ onSortChange,sortOptions,selectedSort,setSelectedSort}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSort = (option) => {
    setSelectedSort(option?.value);
    onSortChange(option);
    handleClose();
  };

    const handleClear = () => {
    setSelectedSort("");
    onSortChange(""); // Send empty value for "clear"
    handleClose();
  };

  return (
    <>
      <ButtonBase onClick={handleClick} sx={{ p: 1 }}>
        <SortIcon sx={{ mr: 1 }} />
        {sortOptions[selectedSort-1]?.label || "Sort By"}
      </ButtonBase>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {sortOptions.map((option) => (
          <MenuItem key={option.value} onClick={() => handleSort(option)}>
            {option.label}
          </MenuItem>
        ))}
            <MenuItem onClick={handleClear}>Clear</MenuItem>
      </Menu>
    </>
  );
};

export default SortMenu;
